var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMouseClickRightDrag = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 8 2.0625-2.0625v1.375h2.75v1.375h-2.75v1.375zm22 0-2.0625 2.0625v-1.375h-2.75v-1.375h2.75v-1.375z",
    fillRule: "evenodd",
    opacity: 0.55
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12.5 9h2v-1h-2zm-7-3.5v5a5.5 5.5 0 0 0 11 0v-5a5.5 5.5 0 0 0 -11 0zm5-4.4494v1.0412a1.49569 1.49569 0 0 0 -1 1.4082v2.5h-3v-.5a4.49037 4.49037 0 0 1 4-4.4494zm.5 1.9494a.50057.50057 0 0 1 .5.5v3a.5.5 0 0 1 -1 0v-3a.50057.50057 0 0 1 .5-.5zm-4.5 7.5v-3.5h3.0918a1.49151 1.49151 0 0 0 2.8164 0h3.0918v3.5a4.5 4.5 0 0 1 -9 0z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMouseClickRightDrag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mouse-click-right-drag.d79d594ec4406dd02c8bdde153606e6d.svg";